var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import report from '../report';
function defaultCodeStrategy(ctx, res) {
    var code = res.code, logId = res.logId;
    var url = ctx.url, req = ctx.req;
    report.error(url, { type: 'response', code: code, logId: logId, url: url }, { res: res, req: req });
    return __assign({ success: false }, res);
}
function defaultExecStrategy(ctx, res) {
    var data = res.data;
    return __assign(__assign({}, res), { success: false, message: data === null || data === void 0 ? void 0 : data.copywriting });
}
var codeStrategy = {};
var execStrategy = {};
var api = /\/act\/\d{4,}\/process\/exec\/v2/;
export var codeMiddleware = function (args) {
    if (args === void 0) { args = { include: api }; }
    return function (ctx, next) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, url, _b, useParseMiddleware, include, conditions, match, response, logId, res, code, data, fn, fn;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = ctx.req, url = _a.url, _b = _a.useParseMiddleware, useParseMiddleware = _b === void 0 ? true : _b;
                    if (!!useParseMiddleware) return [3 /*break*/, 2];
                    return [4 /*yield*/, next()];
                case 1: return [2 /*return*/, _c.sent()];
                case 2:
                    include = args.include;
                    conditions = [].concat(include);
                    match = conditions.some(function (condition) {
                        if (typeof condition === 'function') {
                            return condition(url);
                        }
                        return condition.test(url);
                    });
                    if (!!match) return [3 /*break*/, 4];
                    return [4 /*yield*/, next()];
                case 3: // 启用code中间件时才进行后续处理
                return [2 /*return*/, _c.sent()];
                case 4:
                    ctx.req.codeMiddleware = true; // 满足启用条件，标记启用状态码中间件
                    return [4 /*yield*/, next()];
                case 5:
                    _c.sent();
                    response = ctx.res.clone();
                    logId = response.headers.get('x-tt-logid') || '';
                    return [4 /*yield*/, response.json()];
                case 6:
                    res = _c.sent();
                    code = res.code, data = res.data;
                    if (code === 0 && (data === null || data === void 0 ? void 0 : data.process_exec_code) === 0) {
                        return [2 /*return*/, __assign({ success: true, logId: logId }, res)];
                    }
                    if (code !== 0) {
                        fn = codeStrategy[code];
                        if (fn) {
                            return [2 /*return*/, fn(ctx, __assign(__assign({}, res), { logId: logId }))];
                        }
                        return [2 /*return*/, defaultCodeStrategy(ctx, __assign(__assign({}, res), { logId: logId }))];
                    }
                    else if ((data === null || data === void 0 ? void 0 : data.process_exec_code) !== 0) {
                        fn = execStrategy[data === null || data === void 0 ? void 0 : data.process_exec_code];
                        if (fn) {
                            return [2 /*return*/, fn(ctx, __assign(__assign({}, res), { logId: logId }))];
                        }
                        return [2 /*return*/, defaultExecStrategy(ctx, __assign(__assign({}, res), { logId: logId }))];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
};
export function strategyCreator(type, code, handler) {
    var strategy = type === 'code' ? codeStrategy : execStrategy;
    strategy[code] = handler;
}
export function isStrategyReturnType(p) {
    return 'success' in p;
}
//# sourceMappingURL=code.js.map